module.exports = __webpack_public_path__ + "assets/img/release-file.b6f39f80.svg";